import React from "react";
import { Tooltip, Typography, Avatar } from "antd";
import {
  InfoCircleOutlined,
  FileExcelOutlined,
  CarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./ListUpdateHistory.scss";

const { Text } = Typography;

const activities = [
  {
    date: "15/01/2024",
    time: "14:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
  {
    date: "02/01/2024",
    time: "08:00",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "seratima@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin hồ sơ khách hàng",
        vehicles: [
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
    ],
  },
  {
    date: "01/01/2024",
    time: "14:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
  {
    date: "01/01/2024",
    time: "7:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
];

const ActivityTimeline: React.FC = () => {
  return (
    <div className="activity-timeline">
      {activities.map((item, index) => (
        <div
          key={index}
          className={`timeline-item ${index === activities.length - 1 ? "is-last" : ""}`}
        >
          {/* Line trong item */}
          {index !== activities.length - 1 && <div className="timeline-line" />}

          {/* Cột thời gian */}
          <div className="timeline-time">
            <Text>{item.date}</Text>
            <br />
            <Text>
              {item.time}
            </Text>
          </div>

          {/* Avatar */}
          <div className="timeline-center">
            <div className="timeline-avatar-icon">
              <img height='100%' src="/logo-full.svg" alt="THACO AUTO CRM" />
            </div>
          </div>

          {/* Nội dung */}
          <div className="timeline-content">
            <div className="timeline-user">
              <Text>{item.user} </Text>
              <span className="cl096DD9 mr-4px">(NV1000)</span>
              <Text type="secondary">| {item.department}</Text>
            </div>
            <div className="timeline-email">{item.email}</div>

            <div className="group-timeline-action">
              {item.actions.map((a, i) => (
                <div key={i} className="timeline-action">
                  <span>{a.text}</span>
                  {a.vehicles && (
                    <Tooltip
                      placement="right"
                      color="white"
                      overlayClassName="content-tooltip-420-300"
                      title={
                        <div className="t-cotent-p-12">
                          {a.vehicles.map((v, vi) => (
                            <div key={vi} className="vehicle-item">
                              <div className="vehicle-info">
                                <div className="vehicle-name">
                                  <Text strong>{v.name}</Text>
                                </div>
                                <div className="vehicle-detail">
                                  <div className="cl-344054">
                                    <Text type="secondary">Biển số: </Text>
                                    {v.bien}
                                  </div>
                                  <div className="cl-344054">
                                    <Text type="secondary">Số khung: </Text>
                                    {v.khung}
                                  </div>
                                </div>
                                <div className="vehicle-file">
                                  <Text type="secondary">File: </Text>
                                  <FileExcelOutlined className="file-icon" />
                                  {v.file}
                                </div>
                              </div>
                              <div className="vehicle-arrow">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.42871 1.35636V2.69564C3.42871 2.78671 3.47335 2.87243 3.54657 2.926L10.5394 7.99922L3.54657 13.0724C3.47335 13.126 3.42871 13.2117 3.42871 13.3028V14.6421C3.42871 14.7581 3.56085 14.826 3.6555 14.7581L12.3359 8.46172C12.6501 8.23314 12.6501 7.76529 12.3359 7.5385L3.6555 1.24207C3.56085 1.17243 3.42871 1.24029 3.42871 1.35636Z" fill="#1890FF" />
                                </svg>
                              </div>
                            </div>
                          ))}
                        </div>
                      }
                    >
                      <div className="count-number-E6F7FF">
                        3
                        <InfoCircleOutlined className="info-icon" />
                      </div>
                    </Tooltip>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
